
const response = {
    "payload": [
        {
            "idCategoriaComercial": 14,
            "nombre": "Carolina",
            "descripcion": "Carolina",
            "icono": "https://beneflex-icons.s3.amazonaws.com/categories/gamepad-2.svg",
            "idImagenCategoria": 19,
            "estado": "ACTIVO",
            "nombreCategoriaTipoBeneficio": "Carolina",
            "idCategoriaBeneficio": 164218,
            "nombreTipoCategoriaComercial": "Carolina",
            "idTipoCategoriaComercial": 1,
            "responsable": "jo",
            "correo": "Carolina@email.com",
            "telefono": "5443355",
            "modo": "Marketplace"
        },
        {
            "idCategoriaComercial": 13,
            "nombre": "Alex",
            "descripcion": "Alex",
            "icono": "https://beneflex-icons.s3.amazonaws.com/categories/convenios.svg",
            "idImagenCategoria": 12,
            "estado": "ACTIVO",
            "nombreCategoriaTipoBeneficio": "Económico",
            "idCategoriaBeneficio": 1,
            "nombreTipoCategoriaComercial": "Financiera",
            "idTipoCategoriaComercial": 9,
            "responsable": "Josemmm",
            "correo": "jose@email.com",
            "telefono": "2334455444",
            "modo": "Marketplace"
        },
        {
            "idCategoriaComercial": 8,
            "nombre": "prueba 1",
            "descripcion": "prueba 1",
            "icono": "https://beneflex-icons.s3.amazonaws.com/categories/comunicacion.svg",
            "idImagenCategoria": 11,
            "estado": "ACTIVO",
            "nombreCategoriaTipoBeneficio": "Vestier",
            "idCategoriaBeneficio": 164218,
            "nombreTipoCategoriaComercial": "Personal",
            "idTipoCategoriaComercial": 1,
            "responsable": "prueba 1",
            "correo": "prueba1@lucas.com",
            "telefono": "3333333333",
            "modo": "Marketplace"
        },
    ]

}
const responseDelete = {

    "payload": [

        { "code": 'U2', 
          "message": 'Se ha eliminado exictosamente jeje'},

    ]
}
export const service = {
    getCategoriesMarketplace: () => new Promise(resolve => {
        setTimeout(resolve({ data: response }), 1000);
    }),
    getCategoriesMarketplacedelete: () => new Promise(resolve => {
        setTimeout(resolve({ data: responseDelete }), 1000);
    }),

}